$('.menu-toggle-button').on('click', function(e) {
    e.preventDefault();
    $('.logo').toggle();
    $('.site-type-container').toggle();
    $('#content').toggle();
    $('#footer').toggle();
    $(this).toggleClass("active").toggleClass("draw-x");
    $('.mobile-secondary-menu').toggleClass("show-menu");
    $('.nav-main-wrap').toggleClass("active");
    if($('.sub-menu').hasClass('open')) {
        hideSubMenu()
    }
});

$('.go-back').on('click', function(e) {
    e.preventDefault();
    hideSubMenu();
});

function hideSubMenu() {
    $('.sub-menu').removeClass('open');
    $('.sub-menu').css('display', 'none');
    $('.nav-main-item').removeClass('active')
}